import { StoreBaseHandler } from "../../../../infrastructure/base-handlers";
import { setCommonFilterValue } from "./actions";
import { SetCommonFilter } from "./request";

export class SetCommonFilterHandler extends StoreBaseHandler {
  async handle(request: SetCommonFilter) {
    try {
      this.store.dispatch(setCommonFilterValue(request.payload));
    } catch (e) {
      console.error(e.message);
    }
  }
}
